import { format } from 'svelte-i18n';
import { toast } from '@Shelly/shelly-design-system';
import { get } from 'svelte/store';
import { device_ui } from 'src/stores/features/device-ui';
import { DeviceUIField, type DeviceUIQuickControlTimer } from 'src/types/DeviceUI';
import { duiDelete, duiSaveField } from 'src/services/php-api/device_ui';

export interface QuickControlEntry {
	hr?: string;
	min: string;
	sec: string;
	icon?: string;
}

export const predefinedEntries = (): QuickControlEntry[] => {
	return [
		{ min: '00', sec: '30' },
		{ min: '1', sec: '00' },
		{ min: '3', sec: '00' },
		{ min: '5', sec: '00' },
		{ min: '15', sec: '00' },
	];
};

const resolveErrorMessage = (errors?: Record<string, unknown>): string => {
	if (!errors || Object.keys(errors).length === 0) {
		return 'Unknown error';
	}

	const firstKey = Object.keys(errors)[0];
	const firstValue = (errors as Record<string, unknown>)?.[firstKey];

	return firstValue ? String(firstValue) : 'Unknown error';
};

export const saveCustomTimer = async (deviceId: string, timer: DeviceUIQuickControlTimer) => {
	const $format = get(format);

	try {
		const result = await duiSaveField(deviceId, DeviceUIField.QUICK_CONTROL_TIMER, timer);

		if (!result?.isok) {
			const message = resolveErrorMessage(result?.errors);
			throw new Error(message);
		}
	} catch (error) {
		console.error('Error saving custom timer:', error);
		toast.open({
			type: 'danger',
			title: $format('toast_custom_timer_save_error', {
				default: 'Error saving custom timer',
			}),
		});
	}
};

export const getCustomTimer = (deviceId: string): DeviceUIQuickControlTimer | null => {
	let timer = device_ui.getDeviceUIField(deviceId, DeviceUIField.QUICK_CONTROL_TIMER);
	return timer as DeviceUIQuickControlTimer | null;
};

export const deleteCustomTimer = async (deviceId: string) => {
	const $format = get(format);

	try {
		// Save null to delete the field from backend and store
		const result = await duiDelete(deviceId);

		if (!result?.isok) {
			const message = resolveErrorMessage(result?.errors);
			throw new Error(message);
		}
	} catch (error) {
		console.error('Error deleting custom timer:', error);
		toast.open({
			type: 'danger',
			title: $format('toast_custom_timer_delete_error', {
				default: 'Error deleting custom timer',
			}),
		});
	}
};
